/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
// @ts-ignore
import type { UpdateEmailContentRequestDto } from '../models';
/**
 * RestAIEmailUpdaterApi - axios parameter creator
 */
export const RestAIEmailUpdaterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {UpdateEmailContentRequestDto} updateEmailContentRequestDto 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailContent: async (userId: string, emailId: string, updateEmailContentRequestDto: UpdateEmailContentRequestDto, resourceType?: ResourceTypeDto, resourceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateEmailContent', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('updateEmailContent', 'emailId', emailId)
            // verify required parameter 'updateEmailContentRequestDto' is not null or undefined
            assertParamExists('updateEmailContent', 'updateEmailContentRequestDto', updateEmailContentRequestDto)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/ai`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resourceId'] = resourceId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailContentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAIEmailUpdaterApi - functional programming interface
 */
export const RestAIEmailUpdaterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAIEmailUpdaterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {UpdateEmailContentRequestDto} updateEmailContentRequestDto 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmailContent(userId: string, emailId: string, updateEmailContentRequestDto: UpdateEmailContentRequestDto, resourceType?: ResourceTypeDto, resourceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmailContent(userId, emailId, updateEmailContentRequestDto, resourceType, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAIEmailUpdaterApi.updateEmailContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAIEmailUpdaterApi - factory interface
 */
export const RestAIEmailUpdaterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAIEmailUpdaterApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {UpdateEmailContentRequestDto} updateEmailContentRequestDto 
         * @param {ResourceTypeDto} [resourceType] 
         * @param {string} [resourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmailContent(userId: string, emailId: string, updateEmailContentRequestDto: UpdateEmailContentRequestDto, resourceType?: ResourceTypeDto, resourceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEmailContent(userId, emailId, updateEmailContentRequestDto, resourceType, resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAIEmailUpdaterApi - interface
 */
export interface RestAIEmailUpdaterApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {UpdateEmailContentRequestDto} updateEmailContentRequestDto 
     * @param {ResourceTypeDto} [resourceType] 
     * @param {string} [resourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmailContent(userId: string, emailId: string, updateEmailContentRequestDto: UpdateEmailContentRequestDto, resourceType?: ResourceTypeDto, resourceId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestAIEmailUpdaterApi - object-oriented interface
 */
export class RestAIEmailUpdaterApi extends BaseAPI implements RestAIEmailUpdaterApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {UpdateEmailContentRequestDto} updateEmailContentRequestDto 
     * @param {ResourceTypeDto} [resourceType] 
     * @param {string} [resourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEmailContent(userId: string, emailId: string, updateEmailContentRequestDto: UpdateEmailContentRequestDto, resourceType?: ResourceTypeDto, resourceId?: string, options?: RawAxiosRequestConfig) {
        return RestAIEmailUpdaterApiFp(this.configuration).updateEmailContent(userId, emailId, updateEmailContentRequestDto, resourceType, resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}

